import React, { useEffect, useRef, useState } from 'react';
import { get, post, del } from '../utils/api';

const BASE = '/api';
const getToken = () => localStorage.getItem('token');

const uploadTemplate = async (name, file) => {
  const fd = new FormData();
  fd.append('name', name);
  fd.append('file', file);
  const res = await fetch(`${BASE}/templates`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}` },
    body: fd,
  });
  if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.error || 'Ошибка'); }
  return res.json();
};

const TEMPLATE_VARS = [
  ['ФАМИЛИЯ', 'ИМЯОТЧ', 'ФИО', 'ФИО_РОДИТ', 'ДАТА_РОЖДЕНИЯ'],
  ['ПАСПОРТ_СЕРИЯ', 'ПАСПОРТ_НОМЕР', 'ПАСПОРТ_ВЫДАН', 'ПАСПОРТ_ДАТА'],
  ['ТЕЛЕФОН', 'EMAIL'],
  ['СТУДИЯ', 'КВАРТИРА', 'АДРЕС', 'СОБСТВЕННИК'],
  ['СТАВКА', 'ЗАЛОГ'],
  ['ЗАЛОГ_ЧАСТЬ_1', 'ЗАЛОГ_ЧАСТЬ_2', 'ЗАЛОГ_ЧАСТЬ_3', 'ЗАЛОГ_РАССРОЧКА'],
  ['СУММА_ПЕРВЫЙ_МЕСЯЦ', 'ДНЕЙ_ПЕРВЫЙ_МЕСЯЦ'],
  ['ДАТА_НАЧАЛА', 'ДАТА_ОКОНЧАНИЯ', 'ДАТА_НАЧАЛА_ДЛИННАЯ'],
  ['СПОСОБ_ОПЛАТЫ'],
];

function TemplatesSection() {
  const [templates, setTemplates] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [tplName, setTplName] = useState('');
  const [err, setErr] = useState('');
  const fileRef = useRef();

  const loadTemplates = () => get('/templates').then(setTemplates).catch(() => {});
  useEffect(() => { loadTemplates(); }, []);

  const handleUpload = async () => {
    const file = fileRef.current?.files[0];
    if (!file) return setErr('Выберите файл .docx');
    if (!file.name.endsWith('.docx')) return setErr('Только файлы .docx');
    setUploading(true); setErr('');
    try {
      await uploadTemplate(tplName || file.name, file);
      setTplName('');
      if (fileRef.current) fileRef.current.value = '';
      loadTemplates();
    } catch (e) { setErr(e.message); }
    finally { setUploading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить шаблон?')) return;
    await del(`/templates/${id}`);
    loadTemplates();
  };

  return (
    <div className="card" style={{ marginBottom: 20 }}>
      <div className="section-title" style={{ marginBottom: 12 }}>Шаблоны договоров (.docx)</div>
      <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16, lineHeight: 1.6 }}>
        Загрузите шаблон договора в формате .docx. В тексте шаблона используйте переменные в фигурных скобках: <code style={{ background: 'var(--bg3)', padding: '1px 6px', borderRadius: 4 }}>{'{'}ПЕРЕМЕННАЯ{'}'}</code>.
      </p>

      {/* Variable reference */}
      <div style={{ background: 'var(--bg3)', borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 12 }}>
        <div style={{ fontWeight: 600, marginBottom: 8, color: 'var(--text2)' }}>Доступные переменные:</div>
        {TEMPLATE_VARS.map((group, i) => (
          <div key={i} style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 6 }}>
            {group.map(v => (
              <code key={v} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', padding: '2px 7px', borderRadius: 4, color: 'var(--accent)' }}>
                {'{' + v + '}'}
              </code>
            ))}
          </div>
        ))}
      </div>

      {/* Existing templates */}
      {templates.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          {templates.map(t => (
            <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{t.name}</div>
                <div style={{ fontSize: 11, color: 'var(--text3)' }}>{t.filename}</div>
              </div>
              <button className="btn btn-danger btn-sm" onClick={() => handleDelete(t.id)}>Удалить</button>
            </div>
          ))}
        </div>
      )}
      {templates.length === 0 && <p style={{ color: 'var(--text3)', fontSize: 13, marginBottom: 16 }}>Шаблоны не загружены</p>}

      {/* Upload new */}
      {err && <div className="error-msg" style={{ marginBottom: 12 }}>{err}</div>}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div className="form-group" style={{ margin: 0, flex: '1 1 200px' }}>
          <label style={{ fontSize: 12 }}>Название шаблона</label>
          <input value={tplName} onChange={e => setTplName(e.target.value)} placeholder="Договор аренды 2024" />
        </div>
        <div className="form-group" style={{ margin: 0, flex: '1 1 200px' }}>
          <label style={{ fontSize: 12 }}>Файл .docx</label>
          <input type="file" accept=".docx" ref={fileRef} />
        </div>
        <button className="btn btn-primary" onClick={handleUpload} disabled={uploading} style={{ marginBottom: 1 }}>
          {uploading ? 'Загрузка...' : 'Загрузить'}
        </button>
      </div>
    </div>
  );
}

export default function SettingsPage() {
  const [settings, setSettings] = useState({
    smtp_host: '', smtp_port: '587', smtp_user: '', smtp_pass: '', smtp_from: '',
    tinkoff_token: '', tinkoff_account: ''
  });
  const [testEmail, setTestEmail] = useState('');
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [saved, setSaved] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    get('/settings').then(data => setSettings(s => ({ ...s, ...data }))).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true); setSaved(false); setErr('');
    try { await post('/settings', settings); setSaved(true); setTimeout(() => setSaved(false), 3000); }
    catch (e) { setErr(e.message); }
    finally { setSaving(false); }
  };

  const testSmtp = async () => {
    if (!testEmail) return setErr('Введите email для теста');
    setTesting(true); setTestResult(null); setErr('');
    try { await post('/settings/test-email', { to: testEmail }); setTestResult('ok'); }
    catch (e) { setTestResult('error'); setErr(e.message); }
    finally { setTesting(false); }
  };

  const s = f => setSettings(p => ({ ...p, ...f }));

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Настройки</h1>
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Сохранение...' : saved ? '✅ Сохранено' : 'Сохранить'}
        </button>
      </div>

      <div style={{ maxWidth: 600 }}>
        {/* Templates */}
        <TemplatesSection />

        {/* SMTP */}
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="section-title" style={{ marginBottom: 16 }}>Email (SMTP)</div>
          <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 20 }}>
            Используется для двухфакторной аутентификации и отправки уведомлений арендаторам.
          </p>

          {err && <div className="error-msg" style={{ marginBottom: 16 }}>{err}</div>}

          <div className="form-grid">
            <div className="form-group span-2">
              <label>SMTP-сервер</label>
              <input value={settings.smtp_host} onChange={e => s({ smtp_host: e.target.value })} placeholder="smtp.gmail.com" />
            </div>
            <div className="form-group">
              <label>Порт</label>
              <input value={settings.smtp_port} onChange={e => s({ smtp_port: e.target.value })} placeholder="587" />
            </div>
            <div className="form-group">
              <label>Адрес отправителя</label>
              <input value={settings.smtp_from} onChange={e => s({ smtp_from: e.target.value })} placeholder="noreply@example.com" />
            </div>
            <div className="form-group span-2">
              <label>Логин (email)</label>
              <input value={settings.smtp_user} onChange={e => s({ smtp_user: e.target.value })} placeholder="user@gmail.com" />
            </div>
            <div className="form-group span-2">
              <label>Пароль / App password</label>
              <input type="password" value={settings.smtp_pass} onChange={e => s({ smtp_pass: e.target.value })} placeholder="••••••••••••••••" />
            </div>
          </div>

          <div style={{ marginTop: 20, padding: '16px', background: 'var(--bg3)', borderRadius: 8 }}>
            <div className="section-title" style={{ marginBottom: 12 }}>Тест отправки</div>
            <div style={{ display: 'flex', gap: 10 }}>
              <input value={testEmail} onChange={e => setTestEmail(e.target.value)} placeholder="test@example.com" style={{ flex: 1 }} />
              <button className="btn btn-secondary" onClick={testSmtp} disabled={testing}>
                {testing ? 'Отправка...' : 'Отправить тест'}
              </button>
            </div>
            {testResult === 'ok' && <div style={{ color: 'var(--green)', fontSize: 13, marginTop: 8 }}>✅ Письмо успешно отправлено</div>}
            {testResult === 'error' && <div style={{ color: 'var(--red)', fontSize: 13, marginTop: 8 }}>❌ Ошибка: {err}</div>}
          </div>
        </div>

        {/* Tinkoff API */}
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="section-title" style={{ marginBottom: 16 }}>Т-Банк API (автоматический импорт)</div>
          <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 20 }}>
            Укажите токен и номер счёта для загрузки выписки напрямую из Т-Банк без CSV-файла.
            Токен генерируется в личном кабинете T-Business → Настройки → API.
          </p>
          <div className="form-grid">
            <div className="form-group span-2">
              <label>Bearer-токен</label>
              <input type="password" value={settings.tinkoff_token} onChange={e => s({ tinkoff_token: e.target.value })} placeholder="t.xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" />
            </div>
            <div className="form-group span-2">
              <label>Номер счёта (20 цифр)</label>
              <input value={settings.tinkoff_account} onChange={e => s({ tinkoff_account: e.target.value })} placeholder="40702810000000000000" maxLength={20} />
            </div>
          </div>
          {settings.tinkoff_account && (
            <div style={{ marginTop: 12, padding: '10px 14px', background: 'rgba(79,142,247,.1)', borderRadius: 8, fontSize: 13, color: 'var(--accent)' }}>
              ℹ️ IP сервера для белого списка Т-Банк: <strong>85.239.61.26</strong>
            </div>
          )}
        </div>

        {/* 2FA info */}
        <div className="card">
          <div className="section-title" style={{ marginBottom: 12 }}>Двухфакторная аутентификация (2FA)</div>
          <p style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.6 }}>
            2FA включается автоматически для пользователей, у которых заполнен email в профиле, и если настроен SMTP.
            При входе на указанный email отправляется одноразовый код (OTP), действующий 10 минут.
          </p>
          <div style={{ marginTop: 12, padding: '10px 14px', background: 'rgba(79,142,247,.1)', borderRadius: 8, fontSize: 13, color: 'var(--accent)' }}>
            ℹ️ Если SMTP не настроен — вход выполняется без OTP.
          </div>
        </div>
      </div>
    </div>
  );
}
